"use client";
import { useEffect } from "react";

// Helper function to get cookie value by name
const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Export function to get _fbp cookie
export const getFbp = () => {
  const fbp = getCookie("_fbp");
  return getCookie("_fbp");
};

const MetaScript = () => {
  useEffect(() => {
    // Facebook Pixel script
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js",
    );
    window.fbq("init", `${process.env.NEXT_PUBLIC_FB_PIXEL_ID}`); // Replace with your actual Pixel ID
    window.fbq("track", "PageView");

    // Fetch and store _fbp cookie after pixel initialization
    setTimeout(() => {
      const fbpCookie = getFbp();
      if (fbpCookie) {
        window._fbp = fbpCookie;
      }
    }, 1000);
  }, []);

  return (
    <>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${process.env.NEXT_PUBLIC_FB_PIXEL_ID}&ev=PageView&noscript=1`} // Replace with your actual Pixel ID
        />
      </noscript>
    </>
  );
};

export default MetaScript;
